let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("fV6N4")]).then(() => parcelRequire('4qcOB'));